<div mat-dialog-title class="bg-gray py-4 d-flex justify-content-start">
    <h4 class="w-100 m-0">Share Mail</h4>
    <i class="flaticon-close cursor-pointer fs-18 text-black" mat-dialog-close></i>
</div>
<mat-dialog-content class="py-4">
    <form [formGroup]="share_user_form">
        <div class="row">
            <div class="col-sm-6 col-12">
                <!-- {{userFormControl.user_id.value | json}} -->
                <app-user-dropdown-list [control]="userFormControl.user_id"
                        [selecteduser]="userFormControl.user_id.value" [showAlluser]="false" userType=""
                        label="Select User"
                        [multiple]="true"
                        >
                    </app-user-dropdown-list>

                <!-- <mat-form-field appearance="outline" class="w-100">
                    <mat-label class="form-label">
                        Select Users
                    </mat-label>
                    <mat-select class="form-control" formControlName="user_id" msInfiniteScroll
                        (infiniteScroll)="getNextURM()" [complete]="user_offset === total_user_count" multiple>
                        <mat-option>
                            <ngx-mat-select-search [formControl]="user_filter_control" placeholderLabel="Find name..."
                                noEntriesFoundLabel="'No matching name found'"
                                [clearSearchInput]="search_entiry.clear_search_input">
                            </ngx-mat-select-search>
                        </mat-option>
                        <ng-container *ngIf="find_extisting_users?.length">
                            <mat-option *ngFor="let exist_user of find_extisting_users" [value]="exist_user?.id">
                                {{exist_user?.name}} <span *ngIf="exist_user?.role">({{exist_user?.role}})</span>
                            </mat-option>
                        </ng-container>
                        <mat-option *ngFor="let user of user_list" [value]="user?.id">
                            {{user?.name}} <span *ngIf="user?.role">({{user?.role}})</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field> -->

                <div class="text-end">
                    <button type="button" mat-raised-button color="primary" (click)="share()">
                        <i class="ri-share-line"></i> Share User
                    </button>
                </div>
            </div>

            <div class="col-sm-6 col-12">
                <app-university-dropdown [control]="formControl.university"
                        [selectedUniversity]="formControl.university.value">
                    </app-university-dropdown>

                <div class="text-end">
                    <button type="button" mat-raised-button color="primary"  (click)="shareUniversity()">
                        <i class="ri-share-line"></i> Share University
                    </button>
                </div>
            </div>

        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="border-t-1">
    <button mat-raised-button mat-dialog-close color="warn">Close</button>
</mat-dialog-actions>